<template>
  <AuthLayout :pitch="false">
    <div class="goodbye">
      <h1>Vous êtes déconnecté</h1>
      <p>Votre session est fermée. Vous pouvez vous reconnecter à tout moment.</p>
      <div class="actions">
        <router-link to="/login" class="pub-btn pub-btn--primary">Me reconnecter</router-link>
        <a :href="siteUrl" class="pub-btn pub-btn--ghost">Retour au site</a>
      </div>
    </div>
  </AuthLayout>
</template>

<script>
  import AuthLayout from "@/components/public/AuthLayout.vue";
  import {SITE_URL} from "@/components/public/siteLinks";

  export default {
    name: 'LogoutView',
    components: {AuthLayout},
    data() {
      return {
        siteUrl: SITE_URL,
      }
    },
    mounted(){
      localStorage.clear();
      // Send a notification to the navbar for a rerender it
      window.dispatchEvent(new CustomEvent('isConnectedChange', { detail: { isConnected : false } }));
    }
  }
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.goodbye
  h1
    margin 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.9rem !important
    line-height 1.15
    text-align left
  p
    margin 12px 0 0
    color PUB_INK_SOFT
    font-family PUB_FONT_TEXT
    line-height 1.55
  .actions
    display flex
    flex-direction column
    gap 12px
    margin-top 24px
</style>
